if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.sticky-atc-bar__button');
        this.priceEl = this.querySelector('.sticky-atc-bar__price');
        this.buttonText = this.button.querySelector('span');
        this.spacer = document.getElementById(`StickyAtcSpacer-${this.dataset.section}`);
      }

      connectedCallback() {
        const productInfo = document.getElementById(`MainProduct-${this.dataset.section}`);
        const buyForm = productInfo?.querySelector('[data-type="add-to-cart-form"]');

        if (buyForm) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', shouldShow);
              this.spacer?.classList.toggle('sticky-atc-bar__spacer--active', shouldShow);
              // Lift the Gorgias chat launcher (and any other bottom-fixed widget
              // hooked via CSS) above the bar so it doesn't overlap the CTA.
              document.body.classList.toggle('sticky-atc-bar-active', shouldShow);
            },
            { threshold: 0 }
          );
          this.observer.observe(buyForm);
        }

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );

        this.button.addEventListener('click', this.handleClick.bind(this));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
        document.body.classList.remove('sticky-atc-bar-active');
      }

      handleClick() {
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        const productInfo = document.getElementById(`MainProduct-${this.dataset.section}`);
        const productForm = productInfo?.querySelector('product-form');
        if (productForm?.form) {
          productForm.form.requestSubmit();
        }
      }

      handleVariantChange({ data: { sectionId, variant, html } }) {
        if (sectionId !== this.dataset.section) return;

        if (!variant) {
          this.button.disabled = true;
          this.buttonText.textContent = window.variantStrings.unavailable;
          return;
        }

        const newPrice = html.getElementById(`StickyAtcPrice-${sectionId}`);
        if (newPrice && this.priceEl) {
          this.priceEl.innerHTML = newPrice.innerHTML;
        }

        const mainSubmitDisabled = html
          .getElementById(`ProductSubmitButton-${sectionId}`)
          ?.hasAttribute('disabled');

        if (mainSubmitDisabled) {
          this.button.disabled = true;
          this.buttonText.textContent = variant.available
            ? window.variantStrings.unavailable
            : window.variantStrings.soldOut;
        } else {
          this.button.disabled = false;
          this.buttonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
